module.exports = __webpack_public_path__ + "img/face1.6571200f.png";